export const INTERACTION_PER_PAGE = 5;
